var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1285,
    strokeMiterlimit: 2.6131,
    points: "12.5,30.324 12.5,29.286  6.313,29.286 6.313,31.975 12.403,31.975 12.403,34.598 6.282,34.598 6.282,33.305  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1285,
    strokeMiterlimit: 2.6131,
    points: "21.877,30.696 21.877,29.286  15.689,29.286 15.689,34.566 21.957,34.566 21.957,33.367  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1285,
    strokeMiterlimit: 2.6131,
    points: "25.277,35.242 25.277,29.286  31.466,29.286 31.466,32.264 25.277,32.264  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1285,
    strokeMiterlimit: 2.6131,
    points: "30.347,32.266 31.544,33.584  31.544,35.242  "
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1285,
    strokeMiterlimit: 2.6131,
    points: "44.57,28.758 44.57,34.566  50.092,34.566  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1285,
    strokeMiterlimit: 2.6131,
    points: "52.198,28.758 52.198,34.566  57.718,34.566  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1285,
    strokeMiterlimit: 2.6131,
    points: "35.472,34.719 40.719,34.719  41.094,34.311 41.094,29.615 40.719,29.239 35.246,29.239 34.905,29.55 34.905,34.279  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollText);
export default __webpack_public_path__ + "static/media/scrollText.3d60b20afdd3c06e35d99de699aad48e.svg";
export { ForwardRef as ReactComponent };